(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow-v1"] && !Shopify.designMode) return;
  try {
    
  let lastWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;

    if (
      (lastWidth > 767 && currentWidth <= 767) ||
      (lastWidth <= 767 && currentWidth > 767)
    ) {
      window.location.reload();
    }

    lastWidth = currentWidth;
  });


  } catch(e) { console.error(e); }
})();
})();
